import { render } from "./SendModal.vue?vue&type=template&id=11bede87&scoped=true"
import script from "./SendModal.vue?vue&type=script&lang=js"
export * from "./SendModal.vue?vue&type=script&lang=js"

import "./SendModal.vue?vue&type=style&index=0&id=11bede87&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11bede87"]])

export default __exports__